import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../shared/base.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class IamService extends BaseService {

    public getIamRoles(idToken: string): Observable<any>;
    public getIamRoles(idToken: string, userType: string): Observable<any>;
    public getIamRoles(idToken: string, userType?: string): Observable<any> {
        let queryParams = new HttpParams();
        queryParams = this.appendQueryParam(queryParams, "user-type", userType);
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/iam-roles`, { headers, params: queryParams });
    }
}